import { cva } from 'class-variance-authority';

export const inputStyles = cva(
    '[appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none !placeholder:text-xs',
    {
        variants: {
            variant: {
                default:
                    'text-gray100 rounded-[8px] font-normal block w-full ps-10 p-2.5  placeholder:text-sm placeholder:font-normal border border-gray focus:ring-primary500 focus:border-primary500 focus:shadow-primary focus:outline-primary500',
                error: 'text-gray100 rounded-[8px] font-normal block w-full ps-10 p-2.5  placeholder:text-sm placeholder:font-normal border border-red25 focus:shadow-error focus:ring-red25 focus:border-red25 focus:outline-red25',
                disabled:
                    'text-gray100 rounded-[8px] font-normal block w-full ps-10 p-2.5  placeholder:text-sm placeholder:font-normal border border-gray bg-offWhite cursor-not-allowed',
                leftNotch:
                    'rounded-none rounded-e-[8px] border border-gray focus:ring-primary500 focus:border-primary500 focus:shadow-primary block flex-1 ps-10 p-2.5  placeholder:text-sm placeholder:font-normal w-full text-sm',
                leftNotchError:
                    'rounded-none rounded-e-[8px] border border-red25 focus:shadow-error focus:ring-red25 focus:border-red25 block flex-1 ps-10 p-2.5  placeholder:text-sm placeholder:font-normal  w-full text-sm',
                leftNotchDisabled:
                    'rounded-none rounded-e-[8px] border border-gray bg-offWhite cursor-not-allowed block flex-1 ps-10 p-2.5  placeholder:text-sm placeholder:font-normal w-full text-sm',
                rightNotch:
                    'rounded-none rounded-l-[8px] border border-gray focus:ring-primary500 focus:border-primary500 focus:shadow-primary block flex-1 ps-10 p-2.5  placeholder:text-sm placeholder:font-normal w-full text-sm',
                rightNotchError:
                    'rounded-none rounded-l-[8px] border border-red25 focus:shadow-error focus:ring-red25 focus:border-red25 block flex-1 ps-10 p-2.5  placeholder:text-sm placeholder:font-normal  w-full text-sm',
                rightNotchDisabled:
                    'rounded-none rounded-l-[8px] border border-gray bg-offWhite cursor-not-allowed block flex-1 ps-10 p-2.5  placeholder:text-sm placeholder:font-normal w-full text-sm'
            },
            spacing: {
                right: 'pr-6',
                left: 'pl-10'
            }
        },
        compoundVariants: [
            {
                variant: 'default'
            }
        ],
        defaultVariants: {
            variant: 'default'
        }
    }
);
